import { queryOptions } from '@tanstack/react-query';
import { ticketController } from './controller';

const keys = {
  all: ['tickets'] as const,
  list: (eventId: string, params?: { page?: number; perPage?: number }) =>
    [...keys.all, eventId, 'list', params] as const,
  detail: (eventId: string, ticketId: string) => [...keys.all, eventId, 'detail', ticketId] as const,
  sessions: (eventId: string, ticketId: string) => [...keys.detail(eventId, ticketId), 'sessions'] as const,
  availableSessions: (eventId: string, ticketId: string) =>
    [...keys.detail(eventId, ticketId), 'available-sessions'] as const,
  publicSessions: (eventId: string, ticketId: string) =>
    [...keys.detail(eventId, ticketId), 'public-sessions'] as const,
};

export const ticketQueries = {
  list: (eventId: string, params?: { page?: number; perPage?: number }) =>
    queryOptions({
      queryFn: () =>
        ticketController.list({
          urlParams: { eventId },
          params: { perPage: params?.perPage ?? 15, page: params?.page ?? 1 },
        }),
      queryKey: keys.list(eventId, params),
      select: ({ data }) => data,
    }),
  sessions: (eventId: string, ticketId: string) =>
    queryOptions({
      queryFn: () => ticketController.listSessions({ urlParams: { eventId, ticketId } }),
      queryKey: keys.sessions(eventId, ticketId),
      select: ({ data }) => data,
      enabled: !!eventId && !!ticketId,
    }),
  // Sessões futuras/em andamento (oculta as já encerradas) — usado no seletor de sessão da adição manual de participante.
  // Chave própria, separada de `sessions`, para não misturar cache com a tela de gestão de sessões (que precisa de todas).
  availableSessions: (eventId: string, ticketId: string) =>
    queryOptions({
      queryFn: () => ticketController.listSessions({ urlParams: { eventId, ticketId }, params: { excludePast: true } }),
      queryKey: keys.availableSessions(eventId, ticketId),
      select: ({ data }) => data,
      enabled: !!eventId && !!ticketId,
    }),
  publicSessions: (eventId: string, ticketId: string) =>
    queryOptions({
      queryFn: () => ticketController.listPublicSessions({ urlParams: { eventId, ticketId } }),
      queryKey: keys.publicSessions(eventId, ticketId),
      select: ({ data }) => data.sessions,
      enabled: !!eventId && !!ticketId,
    }),
};
